package com.wintermar.inspection.core.ui.util.modifier

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

@Composable
fun Modifier.dashBorder(
    radius: Dp,
    color: Color
) =
    this.clip(
        shape = RoundedCornerShape(radius)
    ).drawBehind {
        val strokeWidth = 1.dp.toPx()
        val cornerRadius = radius.toPx()
        val dashPattern = floatArrayOf(10f, 6f) // on / off in px

        // inset so stroke is fully visible inside bounds
        val topLeft = Offset(strokeWidth / 2f, strokeWidth / 2f)
        val drawSize = Size(size.width - strokeWidth, size.height - strokeWidth)

        drawRoundRect(
            color = color,
            topLeft = topLeft,
            size = drawSize,
            cornerRadius = CornerRadius(cornerRadius, cornerRadius),
            style = Stroke(
                width = strokeWidth,
                pathEffect = PathEffect.dashPathEffect(dashPattern, 0f)
            )
        )
    }
